/// <reference types="react-scripts" />

// app name
export const APP_NAME = 'Closer';

// base url for the api
export const API_URL = 'https://closer-cowm.onrender.com';

